import React, { useEffect, useState } from 'react';
import { StatusCodes } from 'http-status-codes';
import { useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';

import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import FnbApi from '~/src/services/api/FnbApi';
import PrintSingleConsolidation from './components/PrintSingleConsolidation';

interface ParamProps {
  id: string;
}

export default function PrintConsolidationList(): JSX.Element {
  const history = useHistory();
  const { id } = useParams<ParamProps>();
  const [consolidate, setConsolidate] = useState([]);

  const getConsolidation = async () => {
    const res = await FnbApi.getInvoicesForConsolidation(id);
    if (res.status === StatusCodes.OK) {
      setConsolidate(res.data);
    }
  };

  useEffect(() => {
    if (id) {
      getConsolidation();
    }
  }, [id]);

  return (
    <div>
      {consolidate?.map((item, i, { length }) => {
        return <PrintSingleConsolidation item={item} isLast={i + 1 === length} />;
      })}
    </div>
  );
}
